"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ganttlab_entities_1 = require("ganttlab-entities");
var ViewMineGitHubStrategy_1 = require("./strategies/ViewMineGitHubStrategy");
var ViewMineGitLabStrategy_1 = require("./strategies/ViewMineGitLabStrategy");
var ViewMine = /** @class */ (function (_super) {
    __extends(ViewMine, _super);
    function ViewMine() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.slug = 'mine';
        _this.name = 'Created by me';
        _this.shortDescription = 'All of the issues you did create';
        _this.slugStrategies = {
            github: new ViewMineGitHubStrategy_1.ViewMineGitHubStrategy(),
            gitlab: new ViewMineGitLabStrategy_1.ViewMineGitLabStrategy(),
        };
        _this.configuration = {
            username: '',
            tasks: {
                page: 1,
                pageSize: 50,
            },
        };
        return _this;
    }
    ViewMine.prototype.setSort = function (sort) {
        throw new Error('Method not implemented.');
    };
    ViewMine.prototype.reverseSort = function () {
        throw new Error('Method not implemented.');
    };
    ViewMine.prototype.setFilter = function (filter) {
        throw new Error('Method not implemented.');
    };
    return ViewMine;
}(ganttlab_entities_1.SourceVisitor));
exports.ViewMine = ViewMine;
//# sourceMappingURL=ViewMine.js.map